import { Component, createSignal, onMount, Show } from "solid-js";
import { FsModalDialog } from "@cof/fs-modal-dialog-wc";
import {
  publishProductEligibilityModalView,
  publishProductEligibilityContactClick,
  publishProductEligibilityReturnClick,
} from "@/services/analytics.service";

interface ProductEligibilityModalProps {
  onClose: (modalRef: FsModalDialog) => void;
}

export const ProductEligibilityModal: Component<
  ProductEligibilityModalProps
> = (props) => {
  let modalRef: FsModalDialog | undefined;
  const [showAlert, setShowAlert] = createSignal(false);

  onMount(() => {
    publishProductEligibilityModalView();
  });

  const handleButtonClick = () => {
    setShowAlert(true);
    publishProductEligibilityContactClick();
  };

  return (
    <fd-mfe-modal-dialog
      ref={modalRef}
      prop:open={true}
      data-testid="product-eligibility-modal"
    >
      <h2 slot="modal-dialog-header" data-testid="product-eligibility-heading">
        Become a Featured Dealer on
        <br />
        Capital One Auto Navigator
      </h2>

      <div slot="modal-dialog-body">
        <p class="mb-FsSpacing3x">
          This exclusive feature boosts your inventory's visibility, making you
          the first dealership high-intent customers see in their Capital One
          Auto Navigator search.
        </p>

        <p class="font-FsFontWeightSemibold mb-FsSpacing15x">
          Here's how it can help your business
        </p>

        <ol class="pl-FsSpacing3x m-0 space-y-FsSpacing15x">
          <li>
            <span class="font-FsFontWeightSemibold">Maximum visibility.</span>{" "}
            Achieve maximum visibility with priority placement at the top of
            Auto Navigator search results as well as placements in other key
            shopping points within Auto Navigator.
          </li>
          <li>
            <span class="font-FsFontWeightSemibold">2x lead generation.</span>{" "}
            Access more high-intent leads and also connect with pre-qualified
            shoppers. Some dealers have seen up to 2x the lead generation
            compared to Badging & Sorting placements alone.
          </li>
        </ol>

        <fd-mfe-divider class="my-FsSpacing2x" />

        <span class="block text-FsClrNeutralGray550 mb-FsSpacing2x">
          Participation is subject to eligibility; contact your sales
          representative for details.
        </span>

        <Show
          when={!showAlert()}
          fallback={
            <fd-mfe-alert prop:variant="favorable" prop:leadingIcon={true}>
              Thank you for your interest. Someone from our sales team will
              contact you shortly
            </fd-mfe-alert>
          }
        >
          <fd-mfe-button
            onClick={handleButtonClick}
            class="w-full mb-FsSpacing1x"
            data-testid="contact-sales-button"
          >
            Contact sales
          </fd-mfe-button>
        </Show>
        <fd-mfe-button
          onClick={() => {
            publishProductEligibilityReturnClick();
            if (modalRef) props.onClose(modalRef);
          }}
          class="w-full mt-FsSpacing1x"
          prop:rank="secondary"
          data-testid="return-to-marketing-button"
        >
          Return to marketing
        </fd-mfe-button>
      </div>
    </fd-mfe-modal-dialog>
  );
};
